import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ImageSharedComponent } from './image.component';

@NgModule({
    declarations: [
        ImageSharedComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        ImageSharedComponent
    ]
})

export class ImageSharedModule {}
